const GradientLoadingSpinner = ({ size = 24 }: { size?: number }) => {
  return (
    <div style={{ width: size, height: size }} className="animate-spin">
      <img
        src="/assets/bettie/gradient_loading_spinner.svg"
        alt="Gradient Loading Spinner"
        className="w-full h-full"
      />
    </div>
  );
};
export default GradientLoadingSpinner;
